import { useEffect, useRef } from "react";
import { Message, MessageRole } from "../types";
import { MessageBubble } from "./MessageBubble";
import { TypingIndicator } from "./TypingIndicator";

interface MessageAreaProps {
  messages: Message[];
  isTyping: boolean;
  userIcon?: string;
}

export const MessageArea = ({ messages, isTyping, userIcon }: MessageAreaProps) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  // 新しいメッセージが追加されたら自動スクロール
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages, isTyping]);

  // TypingIndicatorは、AIメッセージがストリーミング中でない場合のみ表示
  const lastMessage = messages[messages.length - 1];
  const showTypingIndicator = isTyping && lastMessage?.role !== MessageRole.ASSISTANT;

  return (
    <div
      ref={scrollRef}
      className="flex-1 overflow-y-auto p-6 flex flex-col gap-5"
      style={{ scrollbarWidth: "thin", scrollbarColor: "#e0e4e7 transparent" }}
    >
      {messages.map((message) => (
        <MessageBubble
          key={message.id}
          message={message}
          isStreaming={
            isTyping && message.id === lastMessage?.id && message.role === MessageRole.ASSISTANT
          }
          userIcon={userIcon}
        />
      ))}
      {showTypingIndicator && <TypingIndicator />}
    </div>
  );
};
